"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listPaymentCorrectionRequestsResponseSchema = exports.paymentCorrectionRequestSchema = void 0;
const zod_1 = require("zod");
const financial_correction_stage_response_1 = require("./financial-correction-stage.response");
const financial_payment_correction_request_1 = require("../request/financial-payment-correction.request");
/**
 * ONE CORRECTION REQUEST, as either role reads it — the requester's own
 * list and the SuperAdmin's approval queue are the SAME shape, same
 * posture as `opRefundRequestSchema`. Mode/bank names are resolved
 * server-side (never a raw id the screen would have to look up itself),
 * and `current*`/`requested*` are both present so the screen can render a
 * before/after diff without a second request.
 */
exports.paymentCorrectionRequestSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    status: financial_payment_correction_request_1.paymentCorrectionStatusEnum,
    paymentLineId: zod_1.z.string().uuid(),
    paymentId: zod_1.z.string().uuid(),
    paymentNumber: zod_1.z.string().nullable(),
    receiptNumber: zod_1.z.string().nullable(),
    invoiceNumber: zod_1.z.string().nullable(),
    patientName: zod_1.z.string().nullable(),
    amountPaise: zod_1.z.number().int(),
    currentPaymentModeCode: zod_1.z.string(),
    currentPaymentModeName: zod_1.z.string(),
    currentBankAccountLabel: zod_1.z.string().nullable(),
    currentReferenceNumber: zod_1.z.string().nullable(),
    requestedPaymentModeCode: zod_1.z.string(),
    requestedPaymentModeName: zod_1.z.string(),
    requestedBankAccountLabel: zod_1.z.string().nullable(),
    requestedReferenceNumber: zod_1.z.string().nullable(),
    reason: zod_1.z.string(),
    requestedBy: zod_1.z.string().uuid().nullable(),
    requestedByName: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string(),
    /** Where the request is in Request -> Verify -> Approve. See `correctionStageEnum`. */
    stage: financial_correction_stage_response_1.correctionStageEnum,
    verifiedBy: zod_1.z.string().uuid().nullable(),
    verifiedByName: zod_1.z.string().nullable(),
    verifiedAt: zod_1.z.string().nullable(),
    verificationNote: zod_1.z.string().nullable(),
    approvedBy: zod_1.z.string().uuid().nullable(),
    approvedByName: zod_1.z.string().nullable(),
    approvedAt: zod_1.z.string().nullable(),
    decisionReason: zod_1.z.string().nullable(),
    resultingJournalEntryId: zod_1.z.string().uuid().nullable(),
    resultingJournalEntryNumber: zod_1.z.string().nullable(),
});
exports.listPaymentCorrectionRequestsResponseSchema = zod_1.z.object({
    requests: zod_1.z.array(exports.paymentCorrectionRequestSchema),
});
//# sourceMappingURL=financial-payment-correction.response.js.map